import { PageHeader, Empty } from "../../ui";
export default function MessagesPage() {
  return (
    <div>
      <PageHeader title="Messages" subtitle="Open any case and use its Messages tab. Internal updates stay internal until published." />
      <Empty title="Open a case to see messages" hint="Internal notes and customer-facing updates are threaded inside each case." />
    </div>
  );
}
